import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { AdminAction } from '@/app/models/AdminAction';
import { RESOURCES, type Resource } from './resources';

import { type PermissionDto } from '@/app/models/PermissionDto';
import { type AppAbility, type Action } from './ability-context';

export { createEmptyAbility } from './ability-context';
export type { Action, Subject, AppAbility } from './ability-context';

const availableResources = new Set<string>(Object.values(RESOURCES));
const availableActions = new Set<string>(Object.values(AdminAction));

export function defineAbilitiesFor(fullAccess: boolean, permissions: PermissionDto[]): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);
  if (fullAccess) {
    can('manage', 'all');
    return build();
  }

  for (const permission of permissions) {
    if (!availableResources.has(permission.resource.value)) continue;
    const actions = permission.actions.filter((action) => availableActions.has(action.value));
    if (actions.length === 0) continue;
    const resource = permission.resource.value as Resource;
    can(AdminAction.CONSULTAR, resource);
    for (const action of actions) {
      can(action.value as Action, resource);
    }
  }
  return build();
}
